import {Component, Input, OnInit, Optional} from '@angular/core';
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";
import {AbstractComponent} from "@components";
import {
  CompetitorResults,
  CompetitorStageDetail,
  CompetitorStatus, EventItem,
  FINISH_CONTROL_POINT_TYPE, Lookups, MeasurementTypes,
  Race, VisibilityTypes
} from "@model";
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';

@Component({
  selector: 'app-result-details-modal',
  templateUrl: './results-details-modal.component.html',
  styleUrl: './results-details-modal.component.scss'
})
export class ResultsDetailsModalComponent extends AbstractComponent implements OnInit {
  @Input() competitorResults!: CompetitorResults;
  @Input() measurementType: number | undefined = undefined;
  @Input() category: number | undefined = undefined;
  @Input() gender: number | undefined = undefined;
  @Input() isRoundRace:boolean = false;
  @Input() showDistance:boolean = false;
  @Input() race?:Race;
  @Input() event?:EventItem;
  @Input() firstCompetitorResults: CompetitorResults | undefined = undefined;
  @Input({ required: true }) languages: Lookups[] = [];
  @Input() isAdmin: boolean = false;

  isMobile = false;
  isTeam = false;

  list: CompetitorStageDetail[] = [];
  checkpointsIds: string[] = [];
  sgsFinishItem: CompetitorStageDetail | undefined;
  SGS?: { [key: string]: CompetitorStageDetail };
  constructor(@Optional() public activeModal: NgbActiveModal, private breakpointObserver: BreakpointObserver) {
    super();
  }

  expanded: Record<string, boolean> = {};

  ngOnInit() {
    this.isTeam = !!(this.competitorResults?.competitorResultsDetail?.team && this.competitorResults?.competitorResultsDetail?.team.length);
    this.breakpointObserver.observe([Breakpoints.Handset, `(max-width: 991.98px)`])
    .subscribe(result => {
      this.isMobile = result.matches;
    });


    if (this.competitorResults.competitorResultsDetail?.SGS && !this.isRoundRace) {
      this.SGS = this.competitorResults.competitorResultsDetail.SGS;
      this.checkpointsIds = Object.entries(this.SGS).map(([key, value]) => ({ ...value, cp_id:key }))
        .filter((item) => item.tp !== FINISH_CONTROL_POINT_TYPE)
        .sort((a, b) => {
          const sortA = a.ordinalNumber ?? 0;
          const sortB = b.ordinalNumber ?? 0;
          return sortA - sortB;
        }).map((item) => item.cp_id!);
      this.sgsFinishItem = Object.values(this.SGS).find((item) => item.tp === FINISH_CONTROL_POINT_TYPE);
      this.checkpointsIds.forEach(id => {
        this.expanded[id] = false;
      });
      if (this.sgsFinishItem) {
        this.expanded['finish'] = false
      }
    } else if (this.competitorResults.competitorResultsDetail?.laps && this.isRoundRace) {
      const items: CompetitorStageDetail[] = Object.entries(this.competitorResults.competitorResultsDetail.laps).map(([key, value]) => ({ ...value, lp:Number(key) }));
      this.list = items
        .sort((a, b) => a.lp! - b.lp!);
      this.list.forEach(l => {
        this.expanded[l.lp!] = false;
      });
    }
  }

  onClose() {
    this.activeModal.close();
  }

  protected readonly CompetitorStatus = CompetitorStatus;
  protected readonly VisibilityTypes = VisibilityTypes;
  protected readonly MeasurementTypes = MeasurementTypes;

}
